export default function Header() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-lg mx-auto px-4 py-3 flex items-center justify-center">
        <Logo />
      </div>
    </header>
  );
}

function Logo() {
  return (
    <div className="flex items-center gap-1">
      <img src="/logo.svg" alt="Matcher logo" width={28} height={24} />
      <span
        className="text-xl font-semibold"
        style={{ fontFamily: "var(--font-lexend), 'Lexend', sans-serif" }}
      >
        <span className="text-primary-700">mat</span>
        <span className="text-accent-red">cher</span>
      </span>
    </div>
  );
}
